// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 449 ? "course" : chunkId) + "." + {"212":"65525779","449":"8378d848","782":"94c2fe4e"}[chunkId] + ".chunk.css";
};